import coin from 'assets/img/coin.png';
import star from 'assets/img/keepa-star.png';
import logo from 'assets/img/statistics_logo.png';
import users from 'assets/img/users-count.png';
import ImageKit from 'components/Image';
import { memo, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { WalletReport } from 'redux/slice/walletRequestStepOne';
import convertToToman from 'services/toman';
import './Statistics.scss';
import StatisticsCard from './StatisticsCard';

const Statistics = () => {
	const dispatch = useDispatch();
	const [counter, setCounter] = useState(1);
	const [walletData, setData] = useState({});

	useEffect(() => {
		const interval = setInterval(() => {
			setCounter(counter + 1);
		}, 1800000);
		dispatch(WalletReport())
			.unwrap()
			.then((payload) => {
				if (payload.Success) setData(payload.Content);
			});
		return () => clearInterval(interval);
	}, [counter]);

	return (
		<div className="statistics-wrapper">
			<div className="golden_ball"></div>
			<div className="blue_ball"></div>
			<header>
				<ImageKit src={logo} alt="کیپا" width="100%" />
			</header>
			<div className="cards-container">
				<StatisticsCard
					title="تعداد کل درخواست‌های کاربران:"
					icon={users}
					infoKey="تعداد"
					infoValue="کاربر"
					data={convertToToman(walletData.WalletRequestCount)}
				/>
				<StatisticsCard
					title="مبلغ کل درخواست‌های کیف پول:"
					icon={coin}
					infoKey="مبلغ"
					infoValue="تومان"
					data={convertToToman(walletData.WalletRequestSum)}
				/>
			</div>
			<div className="footer-keepa-star">
				<ImageKit src={star} alt="کیپا" width="100%" />
			</div>
		</div>
	);
};
export default memo(Statistics);
